export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const dayLabel = (d) => d.charAt(0).toUpperCase() + d.slice(1);

export function fmtTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const hr = h % 12 === 0 ? 12 : h % 12;
  return `${hr}:${String(m).padStart(2, "0")} ${ampm}`;
}

export const STATUS_LABELS = {
  order_received: "Order Received",
  awaiting_payment: "Awaiting Payment",
  payment_confirmed: "Payment Confirmed",
  preparing: "Preparing",
  ready_for_pickup: "Ready for Pickup",
  out_for_delivery: "Out for Delivery",
  delivered: "Delivered",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const PAYMENT_LABELS = {
  awaiting_payment: "Awaiting Payment",
  payment_submitted: "Payment Submitted — Awaiting Confirmation",
  payment_confirmed: "Payment Confirmed",
};

export const TRACK_STAGES = [
  "order_received",
  "payment_confirmed",
  "preparing",
  "ready_for_pickup",
  "completed",
];
